var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    config           = require("app/config"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap"),
    quickMacroize    = require("enyo/macroize").quickMacroize;

require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.Auth.LoginButton.prototype */ {

    /**
     * @private
     */
    name: "app.Auth.LoginButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-auth-login-button",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "neutral",

    /**
     * @type  {string}
     * @public
     */
    loadingIcon: icons["app.Auth.LoginButton.loading"],

    /**
     * @type  {string}
     * @public
     */
    loggedInIcon: icons["app.Auth.LoginButton.loggedIn"],

    /**
     * @type  {string}
     * @public
     */
    loggedOutIcon: icons["app.Auth.LoginButton.loggedOut"],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);

            // Update content
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.router.matchedPathname", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            authService = this.app.$.authService,
            router      = this.app.$.router,
            loginPath   = quickMacroize("/{$language}/login", {
                language: i18nService.get("language")
            }),
            redirectPath;

        this.set("caption", i18nService.getString("app.Auth.LoginButton.caption"));

        switch (authService.isLoggedIn) {
            case 1:
                this.set("tooltip", i18nService.getString("app.Auth.LoginButton.Tooltip.loggedIn"));
                this.set("icon", this.loggedInIcon);
                this.set("href", null);

                while (this.hasClass("loading")) {
                    this.removeClass("loading");
                }
                break;
            case -1:
                this.set("tooltip", i18nService.getString("app.Auth.LoginButton.Tooltip.loggedOut"));
                this.set("icon", this.loggedOutIcon);

                // We are already on the login page, keep the current url
                if (router.getCurrentPath().substring(0, loginPath.length) === loginPath) {
                    this.set("href", router.getCurrentPath());
                }

                // We need to create our own url with a redirect path.
                else {
                    redirectPath = router.getCurrentPath() || "";
                    redirectPath = "/" + redirectPath.replace(/^\/+/, "");
                    redirectPath = encodeURIComponent(redirectPath);

                    this.set("href", quickMacroize("{$loginPath}/{$redirectPath}", {
                        loginPath:    loginPath,
                        redirectPath: redirectPath
                    }));
                }

                while (this.hasClass("loading")) {
                    this.removeClass("loading");
                }
                break;
            case 0:
            default:
                this.set("tooltip", i18nService.getString("app.Auth.LoginButton.Tooltip.authenticating"));
                this.set("icon", this.loadingIcon);
                this.set("href", null);
                !this.hasClass("loading") && this.addClass("loading");
                break;
        }
    },

    /**
     * Determine whether this button should show.
     *
     * @return  {boolean}  Whether this button should be visible
     */
    shouldShow: function() {
        var authService = this.app.$.authService;

        // Login button can be hard disabled in app config
        if (!get(config, "login.enabled", true)) {
            return false;
        }

        switch (authService.isLoggedIn) {
            case 0:
            case -1:
                return true;
            case 1:
            default:
                return false;
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        onHyperlinkTap.call(this, this);

        // Always propagate so that parent menu can respond and close itself
        return false;
    }

});
